// extracted by mini-css-extract-plugin
module.exports = {"image":"Image-module__image___1Gu67"};